<template>
  <div class="mainbody sha-info-page">
    <div class="sha-info-hero">
      <h1>Contact Us</h1>
      <nav class="sha-info-tabs" aria-label="Information pages">
        <router-link to="/delivery-locations" class="sha-info-tab" exact-active-class="active">Delivery Area</router-link>
        <router-link to="/contact-us" class="sha-info-tab" exact-active-class="active">Contact Us</router-link>
        <router-link to="/policy" class="sha-info-tab" exact-active-class="active">Privacy Policy</router-link>
        <router-link to="/terms-condition" class="sha-info-tab" exact-active-class="active">Terms of Use</router-link>
      </nav>
    </div>
    <div class="container-fluid">
      <div class="col-md-12">
        <div class="bg-fix">
          <div class="text-center">
            <h2 class="base-color">
              Contact Us
            </h2>
            <img src="@/assets/images/icons/border.png" alt="">
          </div>
          <h3 class="green-color">
            If you have any query please feel free to contact
          </h3><br>
          <p><b>Email:</b>
            shahpremiumfoods@gmail.com
          </p>
          <p><b>Phone:</b>
            +33 7 58 51 41 54
          </p>
          <p><b>Website:</b>
            http://www.shahpremiumfoods.com
          </p>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 50);
      });

  });
  import axios from 'axios';

  export default {
    data() {
      return {
      };
    },
    created: function () {

    }
  };
</script>
